import React from 'react';
import PropTypes from 'prop-types';

import ConversationNotificationContent from './conversation_notification_content';
import DismissNotificationButtonContainer from './dismiss_notification_button';
import Notification from './notification';

function NotificationContent({
  body,
  contentClasses,
  containerClasses,
  heading,
  iconClass,
  itemType,
  notificationId,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) {
  return (
    <Notification
      key={`notification-${notificationId}`}
      onClick={onClick}
      containerClasses={containerClasses}
      contentClasses={contentClasses}
      notificationId={notificationId}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ConversationNotificationContent iconClass={iconClass} itemType={itemType} heading={heading} body={body} />
      <DismissNotificationButtonContainer notificationId={notificationId} buttonText="Save For Later" />
    </Notification>
  );
}

NotificationContent.propTypes = {
  body: PropTypes.string,
  contentClasses: PropTypes.string,
  containerClasses: PropTypes.string,
  heading: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  notificationId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
};

export default NotificationContent;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/notification/notification_content.jsx